<template>
  <div class="ns-message-action__container">
    <!-- MESSAGE -->
    <div
      class="ns-message-action__message"
      :class="{ 'ns-message-action__message-row': hideAction }"
    >
      <!-- @slot Content that will show above the message -->
      <div
        v-if="$slots['above-message']"
        class="ns-message-action__above-message"
      >
        <!-- @slot Content that will show above the message -->
        <slot name="above-message" />
      </div>
      <p v-html="message" />
    </div>

    <!-- ACTIONS -->
    <div class="ns-message-action__actions">
      <template v-if="!hideAction">
        <!-- Button for login request -->
        <button
          v-if="actionType === 'login'"
          class="ns-message_action__button primary-outline fluid"
          @click="handleLoginRequest"
        >
          {{ actionLabel }}
        </button>

        <!-- Link to actionUrl -->
        <a
          v-else
          class="ns-message_action__button primary-outline fluid"
          :href="actionUrl"
        >
          {{ actionLabel }}
        </a>
      </template>

      <!-- Link to secondaryUrl -->
      <a
        v-if="!hideSecondaryAction"
        class="ns-message_action__button hit-outline fluid"
        :href="secondaryActionHref"
      >
        {{ secondaryActionLabel }}
      </a>
    </div>
    <!-- POST ACTIONS -->
    <div v-if="$slots['after-action']" class="ns-message-action__after-action">
      <!-- @slot Content that will show after the buttons -->
      <slot name="after-action" />
    </div>
  </div>
</template>

<script>
import { events, util } from "@nuskin/ns-util";
import { UserService } from "@nuskin/ns-account";
import "@nuskin/ns-core-styles/src/dist/main.css";

export default {
  name: "NsMessageAction",
  props: {
    /**
     * Text to display on button
     */
    actionLabel: {
      type: String,
      default: ""
    },
    /**
     * Pass in 'login' to perform login redirect instead of url redirect
     */
    actionType: {
      type: String,
      default: null,
      validator(value) {
        return ["login"].includes(value);
      }
    },
    /**
     * URL to link too when action button clicked
     */
    actionUrl: {
      type: String,
      default: ""
    },
    /**
     * Message to be displayed
     */
    message: {
      type: String,
      default: ""
    },
    /**
     * Text to display on secondary action
     */
    secondaryActionLabel: {
      type: String,
      default: ""
    },
    /**
     * URL for secondary action
     */
    secondaryActionUrl: {
      type: String,
      default: ""
    },
    /**
     * Flag to use an event to perform secondary action
     */
    useEventForSecondaryAction: Boolean
  },
  data() {
    return {
      /**
       * Used to go to a specific URL if override specified
       */
      secondaryActionPDPSKU: ""
    };
  },
  computed: {
    hideAction() {
      return this.actionType === "login" && UserService.isLoggedIn();
    },
    hideSecondaryAction() {
      return !this.secondaryActionLabel;
    },
    secondaryActionHref() {
      return this.useEventForSecondaryAction || !this.secondaryActionUrl
        ? `${util.getLocaleUrl()}products/product.${
            this.secondaryActionPDPSKU
          }.html`
        : this.secondaryActionUrl;
    }
  },
  mounted() {
    events.subscribe(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, item => {
      if (item && item.sku) {
        this.secondaryActionPDPSKU = item.sku;
      }
    });
  },
  methods: {
    /**
     * Request login
     */
    handleLoginRequest() {
      events.publish(events.authentication.REQUEST_FOR_LOGIN);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/global.mixins';
@use '~@nuskin/ns-core-styles/src/scss/colors';

.ns-message-action__container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 15px 15px;
  padding-top: 20px;
  width: 100%;
  background-color: rgba(147, 0, 147, 0.06);
}

.ns-message-action__message {
  display: flex;
  flex-direction: column;
  color: map.get(colors.$themeColors, color-primary-text);
  @include global.p-medium();

  &.ns-message-action__message-row {
    width: 100%;
  }
}

.ns-message-action__above-message {
  margin-bottom: 10px;
}

.ns-message-action__actions {
  margin-top: 10px;
}

.ns-message_action__button {
  margin-top: 15px;
  white-space: nowrap;

  &:first-child {
    margin-top: 0;
  }
}

.ns-message-action__after-action {
  margin-top: 10px;
}

@media (min-width: 768px) {
  .ns-message-action__message-row {
    flex-direction: row;
    justify-content: space-between;

    .ns-message-action__above-message {
      margin-right: 60px;
    }
  }
}

@media (min-width: 1024px) {
  .ns-message-action__container {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 10px 17px;
    padding-top: 15px;
  }

  .ns-message-action__message {
    max-width: 313px;

    &.ns-message-action__message-row {
      max-width: none;
    }
  }

  .ns-message-action__actions {
    margin-top: 0;
    margin-left: 15px;
  }

  .ns-message-action__after-action {
    margin-top: 0;
    margin-left: 15px;
  }
}
</style>
